/**
 * XTRA 浮层（竖向栈，对齐 Skyrover）
 * - Klaviyo：rAF 每帧锚定 Sign Up 圆钮上缘，客服 FAB 与其保持固定间距同步上移
 * - Avada Chatty：桌面端面板 bump bottom/top/max-height（right 与安全区右对齐）
 */
(function () {
  var KL_CLASS = 'has-xtra-kl-teaser';
  var FOLLOW_CLASS = 'is-xtra-teaser-following';
  var syncTimer;
  var resizeObserver = null;
  var lastTeaserEl = null;
  var followRaf = 0;
  var followEl = null;
  var lastFaqBottom = -1;

  function readCssPx(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function visible(el) {
    return !!(el && (el.offsetParent !== null || (el.getClientRects && el.getClientRects().length)));
  }

  function findKlaviyoTeaserEl() {
    var strict = document.querySelector(
      'body div.needsclick[class*="kl-teaser"], body div[class*="kl-teaser-"]'
    );
    if (strict && visible(strict)) return strict;
    var nodes = document.querySelectorAll(
      'body a[class*="kl-"], body button[class*="kl-"], body div[class*="kl-"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var c = (el.className && el.className.toString()) || '';
      if (c.indexOf('teaser') === -1 && c.indexOf('Teaser') === -1) continue;
      if (!visible(el)) continue;
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed') return el;
    }
    return null;
  }

  function findTeaserCircleEl(root) {
    if (!root) return null;
    var candidates = root.querySelectorAll('[role="button"], div, button, a, span');
    var best = null;
    var bestScore = 0;

    for (var i = 0; i < candidates.length; i++) {
      var node = candidates[i];
      var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/sign\s*up/i.test(t) || t.length > 24) continue;
      if (node.offsetWidth < 40 || node.offsetHeight < 40) continue;

      var cs = getComputedStyle(node);
      var w = node.offsetWidth;
      var h = node.offsetHeight;
      var score = Math.min(w, h);
      if (Math.abs(w - h) <= 12) score += 40;
      if (parseFloat(cs.borderRadius) >= Math.min(w, h) * 0.35) score += 30;
      if (cs.display === 'flex' || cs.display === 'inline-flex') score += 10;
      if (score > bestScore) {
        bestScore = score;
        best = node;
      }
    }

    return best;
  }

  /** 主题 body line-height 1.6 会让 Klaviyo 圆形 teaser 两行文案偏上并被 overflow 裁切 */
  function fixKlaviyoTeaserText(root) {
    var best = findTeaserCircleEl(root);
    if (!best) return;

    best.style.setProperty('display', 'flex', 'important');
    best.style.setProperty('flex-direction', 'column', 'important');
    best.style.setProperty('align-items', 'center', 'important');
    best.style.setProperty('justify-content', 'center', 'important');
    best.style.setProperty('text-align', 'center', 'important');
    best.style.setProperty('line-height', '1.05', 'important');
    best.style.setProperty('overflow', 'visible', 'important');
    best.style.setProperty('box-sizing', 'border-box', 'important');

    var textNodes = best.querySelectorAll('span, p, div');
    for (var j = 0; j < textNodes.length; j++) {
      var tn = textNodes[j];
      if (tn === best || !(tn.textContent || '').trim()) continue;
      tn.style.setProperty('line-height', '1.05', 'important');
      tn.style.setProperty('text-align', 'center', 'important');
    }
  }

  /** 每帧把客服 bottom 锚在 Sign Up 圆钮上缘 + 固定间距，与 Klaviyo transform 完全同步 */
  function applyFaqFollowTeaser(el) {
    var root = document.documentElement;
    var anchor = findTeaserCircleEl(el) || el;
    var r = anchor.getBoundingClientRect();
    var vh = window.innerHeight;
    var gap = readCssPx('--xtra-float-gap-teaser-to-faq', 12);
    var cornerBottom = readCssPx('--xtra-float-corner-bottom', 18);
    var faqBottom = cornerBottom;

    if (r.bottom > 0 && r.top < vh) {
      faqBottom = Math.max(cornerBottom, Math.ceil(vh - r.top + gap));
    }

    if (faqBottom === lastFaqBottom) return;
    lastFaqBottom = faqBottom;
    root.style.setProperty('--xtra-float-faq-button-bottom', faqBottom + 'px');
    scheduleBumpFaqPanels();
  }

  function stopTeaserFollow() {
    followEl = null;
    lastFaqBottom = -1;
    if (followRaf) {
      cancelAnimationFrame(followRaf);
      followRaf = 0;
    }
    document.documentElement.classList.remove(FOLLOW_CLASS);
  }

  function startTeaserFollow(el) {
    if (!el) return;
    followEl = el;
    document.documentElement.classList.add(FOLLOW_CLASS);
    if (followRaf) return;

    function tick() {
      if (!followEl || !visible(followEl)) {
        stopTeaserFollow();
        return;
      }
      applyFaqFollowTeaser(followEl);
      followRaf = requestAnimationFrame(tick);
    }

    followRaf = requestAnimationFrame(tick);
  }

  function resetTeaserStackVars() {
    var root = document.documentElement;
    root.classList.remove(KL_CLASS);
    root.classList.remove(FOLLOW_CLASS);
    root.style.removeProperty('--xtra-float-faq-button-bottom');
    root.style.removeProperty('--xtra-float-teaser-measured-h');
  }

  function bindResizeObserver(el) {
    if (typeof ResizeObserver === 'undefined') return;
    if (el === lastTeaserEl && resizeObserver) return;
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
    lastTeaserEl = el;
    resizeObserver = new ResizeObserver(function () {
      fixKlaviyoTeaserText(el);
    });
    resizeObserver.observe(el);
  }

  function syncKlaviyoTeaser() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var root = document.documentElement;
      var el = findKlaviyoTeaserEl();
      if (!el) {
        stopTeaserFollow();
        resetTeaserStackVars();
        if (resizeObserver) {
          resizeObserver.disconnect();
          resizeObserver = null;
        }
        lastTeaserEl = null;
        scheduleBumpFaqPanels();
        return;
      }
      root.classList.add(KL_CLASS);
      fixKlaviyoTeaserText(el);
      applyFaqFollowTeaser(el);
      bindResizeObserver(el);
      startTeaserFollow(el);
    }, 50);
  }

  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(syncKlaviyoTeaser);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncKlaviyoTeaser);
  } else {
    syncKlaviyoTeaser();
  }

  var pollUntil = Date.now() + 90000;
  var poll = setInterval(function () {
    syncKlaviyoTeaser();
    if (Date.now() > pollUntil) clearInterval(poll);
  }, 800);

  var resizeT;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        syncKlaviyoTeaser();
        scheduleBumpFaqPanels();
      }, 100);
    },
    { passive: true }
  );

  /* ========== Avada 大会话窗 bump（桌面） ========== */

  var faqPanelPatched = new WeakSet();
  var bumpRaf = 0;
  var faqMo = null;
  var faqPanelScrollGeneration = 0;
  var faqPanelScrollDoneAtGen = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  /** 打开对话窗后把内部可滚区域滚到底（滑块在轨道下方）；原 Skyrover 为滚顶故滑块会停在最上 */
  function scrollSubtreeToBottom(root) {
    if (!root || root.scrollTop === undefined) return;
    var list = [root];
    try {
      root.querySelectorAll('*').forEach(function (n) {
        list.push(n);
      });
    } catch (e) {
      return;
    }
    list.forEach(function (node) {
      if (!node || node.scrollTop === undefined) return;
      try {
        if (node.scrollHeight <= node.clientHeight + 1) return;
        var oy = getComputedStyle(node).overflowY;
        if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') {
          node.scrollTop = node.scrollHeight - node.clientHeight;
        }
      } catch (e2) {}
    });
    try {
      if (root.scrollHeight > root.clientHeight + 1) {
        root.scrollTop = root.scrollHeight - root.clientHeight;
      }
    } catch (e3) {}
  }

  function maybeScrollPanelToBottom(el) {
    if (!faqPanelScrollDoneAtGen || !matchLargeFixedFaqPanel(el)) return;
    if (faqPanelScrollDoneAtGen.get(el) === faqPanelScrollGeneration) return;
    faqPanelScrollDoneAtGen.set(el, faqPanelScrollGeneration);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollSubtreeToBottom(el);
        setTimeout(function () {
          scrollSubtreeToBottom(el);
        }, 200);
      });
    });
  }

  function panelLooksBottomDocked(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > window.innerHeight - 140;
  }

  function classHintsAvadaOrChatty(el) {
    var c = (el.className && el.className.toString()) || '';
    return /Avada|chatty|Chatty|Faqs|FAQ/i.test(c);
  }

  function matchLargeFixedFaqPanel(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.closest('.Avada-Faqs_Button')) return false;
    if (el.closest('.Avada-FaqsWelcomePopup')) return false;
    if (el.tagName === 'IFRAME') return false;
    if (!classHintsAvadaOrChatty(el)) return false;
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed') return false;
    if (el.offsetWidth < 260 || el.offsetHeight < 220) return false;
    return true;
  }

  function bumpFaqChatPanels() {
    if (typeof window.matchMedia === 'function') {
      if (!window.matchMedia('(min-width: 769px)').matches) return;
    } else if (window.innerWidth <= 768) {
      return;
    }

    var panelRight = 'var(--xtra-float-corner-right)';
    var bottomFinal = 'var(--xtra-float-faq-chat-panel-sum)';
    var topSafe = 'calc(12px + env(safe-area-inset-top, 0px))';
    var maxH =
      'calc(100dvh - 12px - env(safe-area-inset-top, 0px) - var(--xtra-float-faq-chat-panel-sum))';

    function applyOne(el) {
      if (!matchLargeFixedFaqPanel(el)) return;
      var firstPaint = !faqPanelPatched.has(el) && panelLooksBottomDocked(el);
      if (firstPaint) el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('top', topSafe, 'important');
      el.style.setProperty('bottom', bottomFinal, 'important');
      el.style.setProperty('right', panelRight, 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('max-height', maxH, 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
      el.style.setProperty('overflow-y', 'auto', 'important');
      if (firstPaint) {
        void el.offsetHeight;
        requestAnimationFrame(function () {
          el.style.removeProperty('opacity');
          faqPanelPatched.add(el);
          maybeScrollPanelToBottom(el);
        });
      } else {
        maybeScrollPanelToBottom(el);
      }
    }

    var faqRoot = document.getElementById('Avada-FAQ_Widget');
    if (faqRoot) faqRoot.querySelectorAll('*').forEach(applyOne);
    if (document.body) {
      for (var i = 0; i < document.body.children.length; i++) {
        var ch = document.body.children[i];
        if (!classHintsAvadaOrChatty(ch)) continue;
        if (matchLargeFixedFaqPanel(ch)) applyOne(ch);
        ch.querySelectorAll('*').forEach(applyOne);
      }
    }
  }

  function scheduleBumpFaqPanels() {
    cancelAnimationFrame(bumpRaf);
    bumpRaf = requestAnimationFrame(function () {
      bumpFaqChatPanels();
      requestAnimationFrame(bumpFaqChatPanels);
    });
  }

  function attachFaqPanelObserver() {
    var faq = document.getElementById('Avada-FAQ_Widget');
    if (!faq || faqMo) return;
    faqMo = new MutationObserver(function () {
      scheduleBumpFaqPanels();
    });
    faqMo.observe(faq, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachFaqPanelObserver);
  } else {
    attachFaqPanelObserver();
  }

  if (typeof MutationObserver !== 'undefined' && !document.getElementById('Avada-FAQ_Widget')) {
    var faqRootWait = new MutationObserver(function () {
      if (document.getElementById('Avada-FAQ_Widget')) {
        attachFaqPanelObserver();
        faqRootWait.disconnect();
      }
    });
    faqRootWait.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      faqRootWait.disconnect();
    }, 60000);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('#Avada-FAQ_WidgetTrigger, [data-chatty-widget="trigger"]')) return;
      faqPanelScrollGeneration += 1;
      attachFaqPanelObserver();
      scheduleBumpFaqPanels();
      queueMicrotask(bumpFaqChatPanels);
      var n = 0;
      function burst() {
        bumpFaqChatPanels();
        if (++n < 20) requestAnimationFrame(burst);
      }
      requestAnimationFrame(burst);
    },
    true
  );

  scheduleBumpFaqPanels();
})();
